import styled from "styled-components";

export const Wrapper = styled.div`
  margin-bottom: 0.5rem;
  width: 100%;
`;

export const Key = styled.p`
  font-size: 0.875rem;
  color: var(--grey-100);
  margin-bottom: 0.3rem;
`;

export const Value = styled.span`
  font-family: Inter;
  font-size: 16px;
  line-height: 24px;
  color: var(--white);
  overflow: hidden;
  overflow-wrap: break-word;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
`;
